<script setup lang="ts">
  import { ref, onMounted, onUnmounted, computed, watch } from 'vue'
  import MessageServiceCn from '@/components/AppMessageCn/messageCn'
  import _fetch from '@/utils/fetch'

  const props = defineProps({
    show: {
      type: Boolean,
      default: false
    }
  })
  // 如果弹窗组件内部有自己的状态变量，需要同步props变化
  const ShowManagePSW = ref(props.show)

  watch(
    () => props.show,
    newVal => {
      ShowManagePSW.value = newVal
    }
  )

  const emit = defineEmits(['close', 'ok', 'update:show'])
  const createSuccess = ref(false)

  let signing = ref(false)
  const studentAccount = ref('')

  // 生成临时密码
  const createTempPSW = async () => {
    const response = await _fetch('/aigc/api/auth/edu/student/forgot', {
      method: 'POST',
      body: JSON.stringify({
        studentUsername: studentAccount.value
      })
    })
    const res = await response.json()
    if (res.code == 200) {
      // 临时密码生成引导
      createSuccess.value = true
      emit('update:show', false)
    } else {
      MessageServiceCn({
        message: res.msg,
        type: 'error'
      })
    }
  }

  const confirm = () => {
    createSuccess.value = false
    studentAccount.value = ''
  }

  // 计算按钮状态
  const isTempPSWFilled = computed(() => {
    return studentAccount.value.trim()
  })
  const closeDialog = () => {
    emit('update:show', false)
  }

  onMounted(() => {})

  onUnmounted(() => {})
</script>

<template>
  <main id="login_edu_container">
    <div v-if="ShowManagePSW" class="login-mask-container">
      <div class="login-container">
        <a class="detail-close" @click="closeDialog">
          <span class="hitems-close"></span>
        </a>
        <div class="school-login-header">
          <img class="login-logo" src="@/assets/images/logo-zhw.webp" height="32" alt="logo" />
          <span class="school-login-title">教育公益版</span>
        </div>
        <!-- 生成临时密码弹窗 -->
        <div class="login-types">
          <div class="login-btn">
            <input
              v-model="studentAccount"
              class="login-input"
              type="text"
              placeholder="输入学生账号"
            />
          </div>
          <div
            @click="createTempPSW"
            class="login-btn sign-btn"
            :class="{
              'btn-active': isTempPSWFilled,
              'btn-disabled': !isTempPSWFilled,
              'signing': signing
            }"
          >
            生成临时密码
          </div>
        </div>
      </div>
    </div>
    <div v-if="createSuccess" class="login-mask-container create-success">
      <div class="login-container success-container">
        <div class="temp-tips">临时密码已生成:a123456</div>
        <div class="temp-tips">有效期60分钟</div>
        <div class="temp-tips">请提醒学生课后回到造好物公共版找回密码</div>
        <div class="login-types" style="margin-top: 2.4rem">
          <div class="login-btn sign-btn btn-active" style="font-size: 1.6rem" @click="confirm">
            确定
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<style scoped lang="stylus">
  @import './index.styl'
</style>
